export const SET_POLICIES = 'policySearch/SET_POLICIES';

export const CLEAR_SEARCH = 'policySearch/CLEAR_SEARCH';
